import React from 'react';
import { ILocalization } from '../../../types';
import { IResponseData } from '../../../stores/types';
import Cross from '../../icons/cross';
import styles from './detailsModal.scss';
import classNames from 'classnames';
import { DetailsModalContent } from './detailsModalContent/detailsModalContent';
import ArrowSmallIcon from '../../icons/arrowSmallIcon';
import TabNavigationHelper from '../../../helper/tabNavigationHelper';

function DetailsModal({ articleSetItemDetail, localization, isOpen, onClose, variantLabel, detailPageUrl }: IDetailsModal) {
    const detailsModalRef = React.useRef<HTMLDivElement>(null);
    const closeButtonRef = React.useRef<HTMLDivElement>(null);
    const tabNavigation = TabNavigationHelper.instance;

    React.useEffect(() => {
        if (isOpen) {
            tabNavigation.setFocusAtt(closeButtonRef.current);
            window.shell.tabNav.focus(closeButtonRef.current as Element);
        }
    }, [isOpen]);

    if (!isOpen) {
        return <></>;
    }

    function redirectToDetailPage() {
        const dpURL = new URL(detailPageUrl);
        dpURL.searchParams.set('itemorigin', 'ArticleSet');
        window.open(dpURL.href, '_blank');
    }

    return (
        <div className={styles.details_modal} data-testid='details_modal_root' data-semantic-id='details_modal_root'>
            <div ref={detailsModalRef} className={styles.details_modal_container} data-testid='details_modal_container'
              data-semantic-id='details_modal_container'>
                <div
                    className={styles.details_modal_content}
                    data-testid='details_modal_content' data-semantic-id='details_modal_content'
                    ref={(el) => tabNavigation.setModalAtt(el)}
                >
                    <div className={styles.details_modal_header} data-testid='details_modal_header'
                      data-semantic-id='details_modal_header'>
                        <div className={styles.details_modal_text_area}>
                            <span className={styles.details_modal_title} data-testid='details_modal_title'
                              data-semantic-id='details_modal_title'>
                                {articleSetItemDetail?.orderModule.articleInfo.title}
                            </span>
                            <div className={styles.color_size_info} data-testid='details_modal_color_size_info'
                              data-semantic-id='details_modal_color_size_info'>
                                {variantLabel}
                            </div>
                        </div>
                        <div
                            className={styles.close_button}
                            id='article_sets_details_modal_close_button'
                            onClick={onClose}
                            ref={closeButtonRef}
                        >
                            <Cross />
                        </div>
                    </div>
                    <div className={styles.details_modal_middle} data-testid='details_modal_middle'
                      data-semantic-id='details_modal_middle'>
                        <DetailsModalContent data={articleSetItemDetail} />
                    </div>
                    <div className={styles.transition_on_scroll_down} />
                    <div className={styles.details_modal_footer} data-testid='details_modal_footer'
                      data-semantic-id='details_modal_footer'>
                        <div
                            className={classNames(styles.footer_button, styles.white)}
                            id='to_details_page_button'
                            onClick={() => redirectToDetailPage()}
                            ref={(el)=> tabNavigation.setFocusAtt(el)}
                        >
                            <div className={styles.to_details_page}>
                                {localization?.generalL10n.toTheDetailsPage}
                            </div>
                            <ArrowSmallIcon />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

interface IDetailsModal {
    localization: ILocalization;
    isOpen: boolean;
    articleSetItemDetail: IResponseData;
    variantLabel: string;
    detailPageUrl: string;
    onClose?();
}

export default DetailsModal;

